module.exports = __webpack_public_path__ + "img/close.0ca4dc91.svg";